export default {"src":"/_next/static/media/0x429881672b9ae42b8eba0e26cd9c73711b891ca5.a3d6a78f.svg","height":245,"width":245,"blurWidth":0,"blurHeight":0};